theme.headerSearch = (function () {
  /* Overlay scuro sopra l'header per il drawer cerca (z:997 < search-drawer z:998) */
  var _searchOverlay = null;
  function getSearchOverlay() {
    if (!_searchOverlay) {
      _searchOverlay = document.createElement('div');
      _searchOverlay.style.cssText = 'display:none;position:fixed;inset:0;background:rgba(0,0,0,0.5);z-index:997;';
      document.body.appendChild(_searchOverlay);
    }
    return _searchOverlay;
  }

  /* Resetta la predictive-search: svuota input + risultati.
     Fix ghost-click iOS: durante i 500ms di transizione di chiusura il drawer è
     ancora visibility:visible; i tap "fantasma" colpivano link/submit e causavano
     redirect imprevisti. Pulire lo stato al momento della chiusura evita il problema. */
  function resetPredictiveSearch(overlay) {
    var ps = overlay.querySelector('predictive-search');
    if (ps && typeof ps.close === 'function') ps.close(true);
  }

  function searchOverlay(e) {
    let input = e.querySelector('input[type="search"]');

    let drawerAction = (trigger, closeTrigger, wrapper) => {
      let offcanvasSearchTrigger = document.querySelectorAll(trigger),
        offcanvasSidebarSearch = document.querySelector(wrapper),
        offcanvasSearchClose = document.getElementById(closeTrigger);

      offcanvasSearchTrigger.forEach((singleTrigger) => {
        if (singleTrigger) {
          singleTrigger.addEventListener("click", (event) => {
            event.preventDefault();
            offcanvasSidebarSearch.classList.add("active");
            document.querySelector("body").classList.add("added__overlay_search");
            getSearchOverlay().style.display = 'block';

            offcanvasSidebarSearch.addEventListener(
              "transitionend",
              () => {
                trapFocus(offcanvasSidebarSearch);
                trapFocus(input);
              },
              { once: true }
            );
          });

          offcanvasSidebarSearch.addEventListener("keyup", (evt) => {
            if (evt.code === "Escape") {
              offcanvasSidebarSearch.classList.remove("active");
              document.querySelector("body").classList.remove("added__overlay_search");
              if (_searchOverlay) _searchOverlay.style.display = 'none';
              removeTrapFocus(singleTrigger);
              resetPredictiveSearch(offcanvasSidebarSearch);
            }
          });

          if (offcanvasSearchClose) {
            offcanvasSearchClose.addEventListener("click", (event) => {
              event.preventDefault();
              offcanvasSidebarSearch.classList.remove("active");
              document.querySelector("body").classList.remove("added__overlay_search");
              if (_searchOverlay) _searchOverlay.style.display = 'none';
              removeTrapFocus(singleTrigger);
              resetPredictiveSearch(offcanvasSidebarSearch);
            });
          }
        }
      });

      if (offcanvasSidebarSearch) {
        document.addEventListener("click", function (event) {
          let eventTarget = event.target;
          if (
            !eventTarget.closest("#predictive__search_overlay") &&
            !eventTarget.closest(".header__actions_btn--search")
          ) {
            offcanvasSidebarSearch.classList.remove("active");
            document.querySelector("body").classList.remove("added__overlay_search");
            if (_searchOverlay) _searchOverlay.style.display = 'none';
            resetPredictiveSearch(offcanvasSidebarSearch);
          }
        });
      }
    };

    drawerAction(
      ".header__actions_btn--search",
      "search__close_btn",
      "#predictive__search_overlay"
    );
  }
  return searchOverlay;
})();
